export const home = {
  // Hero section
  "hero.title": "Find the Best Suppliers in Nigeria",
  "hero.subtitle": "Discover and contact businesses directly based on your criteria.",
  "hero.search_placeholder": "Search for products, services or businesses",
  "hero.location_placeholder": "Your location",
  "hero.cta": "Search Now",
  "hero.badge_trusted": "Access over {{count, number}} Nigerian businesses",

  // Stats section
  "stats.suppliers": "Suppliers",
  "stats.categories": "Categories", 
  "stats.cities": "States",
  "stats.reviews": "Reviews",
  "stats.states": "States",
  "stats.transactions": "Transactions",
  "stats.rating": "Rating",

  // Categories section
  "categories.title": "Popular Categories",
  "categories.subtitle": "Explore our top business categories",
  "categories.view_all": "View All Categories",

  // Premium section
  "premium.title": "Premium Suppliers",
  "premium.subtitle": "Discover our premium verified suppliers",
  "premium.verified": "Verified",
  "premium.view_profile": "View Profile",
  "premium.no_businesses": "No premium suppliers",
  "premium.no_businesses_desc": "There are currently no premium suppliers. Check back later!",
  "premium.no_suppliers": "No premium suppliers",
  "premium.verified_badge": "Verified",
  "premium.view_details": "View details",
  "premium.retry": "Retry",
  "premium.contact": "Contact",
  "premium.full_address_available": "Full address available",
  "premium.no_suppliers_desc": "There are currently no premium suppliers. Check back later!",

  // How it works
  "how.title": "How It Works",
  "how.step1.title": "Search",
  "how.step1.desc": "Find businesses by category or location",
  "how.step2.title": "Compare", 
  "how.step2.desc": "Check reviews and ratings",
  "how.step3.title": "Connect",
  "how.step3.desc": "Get in touch directly",

  // CTA section
  "cta.title": "Are you a supplier?",
  "cta.subtitle": "Join our platform and grow your business",
  "cta.button": "Create Supplier Account",

  // Newsletter section
  "newsletter.title": "Stay informed",
  "newsletter.stay_informed": "Stay informed",
  "newsletter.subtitle": "Subscribe to our newsletter to receive the latest news and updates",
  "newsletter.benefit1": "Receive exclusive offers",
  "newsletter.benefit2": "Discover new suppliers",
  "newsletter.benefit3": "Stay up to date with the latest trends",
  "newsletter.name_placeholder": "Your full name",
  "newsletter.email_placeholder": "your@email.com",
  "newsletter.sector": "Sector",
  "newsletter.select_sector": "Select your sector",
  "newsletter.sector_placeholder": "Select your sector",
  "newsletter.form_title": "Newsletter signup",
  "newsletter.description": "Receive the latest news about suppliers, new businesses and business opportunities in Nigeria.",
  "newsletter.full_name": "Full name",
  "newsletter.submitting": "Subscribing...",
  "newsletter.success_title": "Subscription successful!",
  "newsletter.success_message": "Thank you for subscribing to our newsletter. A confirmation email has been sent to you.",
  "newsletter.already_subscribed": "You are already subscribed to our newsletter.",
  "newsletter.error_title": "Error",
  "newsletter.error_message": "Error during subscription. Please try again.",
  "newsletter.subscribe_button": "Subscribe to newsletter",
  "contact.title": "Are you a supplier?",
  "contact.subtitle": "Join thousands of suppliers and grow your business",
  "contact.register_free": "Register my business for free",
  "contact.talk_advisor": "Talk to an advisor",
  "contact.modal.title": "Talk to an advisor",
  "contact.modal.subtitle": "Olufona is here to help",
  "contact.modal.email": "Email",
  "contact.modal.whatsapp": "WhatsApp",
  "contact.modal.message": "Message",
  "contact.modal.internal_message": "Internal messaging",
  "contact.modal.back": "Back",
  "contact.modal.send_message": "Send a message to Olufona",
  "contact.modal.sent_title": "Message sent!",
  "contact.modal.sent_message": "We will respond as soon as possible.",
  "contact.modal.placeholder": "Write your message here...",
  "contact.modal.sending": "Sending...",
  "contact.modal.send_button": "Send message",
  // Stats section - additional labels
  "stats.product_categories": "Product categories",
  "stats.monthly_searches": "Monthly searches",
  "stats.loading": "Loading suppliers...",
  "stats.loading_slow": "Loading is taking longer than expected",
  "stats.retry": "Retry",

  // Featured/Premium section - additional
  "featured.title": "Featured Suppliers",
  "featured.subtitle": "Discover top-rated suppliers near you",
  "featured.verified": "Verified",
  "featured.contact": "Contact",
  "featured.view_details": "View details",

  // Search tabs (home page)
  "search.tabs.products": "Products",
  "search.tabs.suppliers": "Suppliers"
};

export default home;